import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";

import { getField, updateField } from "vuex-map-fields";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
});

export default new Vuex.Store({
  state: {
    newsletter: false,
    checkoutPrice: null,
    transitionName: "next",
    fromLocation: null,
    toLocation: null,
    typeTransport: "ophaalbestelservice",
    type: null,
    protectionType: null,
    placement: null,
    placementElevator: null,
    verhuislift: "",
    verdieping: 1,
    movementPackage: "",
    klant: {
      type: "particulier",
      voornaam: "",
      achternaam: "",
      email: "",
      telefoonnummer: "",
      bedrijfsnaam: "",
      kvk: ""
    },
    voorwerpen: [
      {
        type: null,
        lengte: null,
        omschrijving: "",
        breedte: null,
        hoogte: null,
        aantal: 1,
        koerier: "nee",
        gewicht: "0-34kg",
        oudspulmeenemen: "nee",
        demontagemontage: "nee",
        packing: "nee"
      }
    ],
    ophaalAdres: {
      contact: "",
      telefoon: "",
      adres: "",
      postcode: "",
      plaatsnaam: "",
      opmerkingen: ""
    },
    afleverAdres: {
      contact: "",
      telefoon: "",
      adres: "",
      postcode: "",
      plaatsnaam: "",
      opmerkingen: ""
    },
    sjouwers: 1,
    uren: 1,
    ophalen: "beganegrond",
    ophalenLift: null,
    ophalenTime: "flex",
    afleverTime: "flex",
    aflever: "beganegrond",
    afleverLift: null,
    zelfdedag: "ja",
    routes: [],
    opmerkingen: null,
    ophalendatum: null,
    afleverdatum: null,
    distanceSummary: null,
    totalKm: null,
    addressSearchFrom: "",
    addressSearchTo: "",
    selectedAddressFrom: null,
    selectedAddressTo: null,
    addressesFrom: [],
    addressesTo: [],
    extraCountryCosts: false,
    isBEOrNL: false
  },
  getters: {
    getField
  },
  mutations: {
    updateField
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin]
});
